import { edeApi, wtsApi } from 'src/api';
import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';

export const LOAD_CONFIGURATION_REQUEST = 'LOAD_CONFIGURATION_REQUEST';
export const LOAD_CONFIGURATION_SUCCESS = 'LOAD_CONFIGURATION_SUCCESS';
export const LOAD_CONFIGURATION_FAIL = 'LOAD_CONFIGURATION_FAIL';

export const PUT_CONFIGURATION_REQUEST = 'PUT_CONFIGURATION_REQUEST';
export const PUT_CONFIGURATION_SUCCESS = 'PUT_CONFIGURATION_SUCCESS';
export const PUT_CONFIGURATION_FAIL = 'PUT_CONFIGURATION_FAIL';

export const LOAD_CONFIGURATION_LUNCH_REQUEST = 'LOAD_CONFIGURATION_LUNCH_REQUEST';
export const LOAD_CONFIGURATION_LUNCH_SUCCESS = 'LOAD_CONFIGURATION_LUNCH_SUCCESS';
export const LOAD_CONFIGURATION_LUNCH_FAIL = 'LOAD_CONFIGURATION_LUNCH_FAIL';

export const PUT_CONFIGURATION_LUNCH_REQUEST = 'PUT_CONFIGURATION_LUNCH_REQUEST';
export const PUT_CONFIGURATION_LUNCH_SUCCESS = 'PUT_CONFIGURATION_LUNCH_SUCCESS';
export const PUT_CONFIGURATION_LUNCH_FAIL = 'PUT_CONFIGURATION_LUNCH_FAIL';

export const LOAD_CONFIGURATION_BREAK_REQUEST = 'LOAD_CONFIGURATION_BREAK_REQUEST';
export const LOAD_CONFIGURATION_BREAK_SUCCESS = 'LOAD_CONFIGURATION_BREAK_SUCCESS';
export const LOAD_CONFIGURATION_BREAK_FAIL = 'LOAD_CONFIGURATION_BREAK_FAIL';

export const PUT_CONFIGURATION_BREAK_REQUEST = 'PUT_CONFIGURATION_BREAK_REQUEST';
export const PUT_CONFIGURATION_BREAK_SUCCESS = 'PUT_CONFIGURATION_BREAK_SUCCESS';
export const PUT_CONFIGURATION_BREAK_FAIL = 'PUT_CONFIGURATION_BREAK_FAIL';

export const LOAD_CONFIGURATION_GENERAL_REQUEST = 'LOAD_CONFIGURATION_GENERAL_REQUEST';
export const LOAD_CONFIGURATION_GENERAL_SUCCESS = 'LOAD_CONFIGURATION_GENERAL_SUCCESS';
export const LOAD_CONFIGURATION_GENERAL_FAIL = 'LOAD_CONFIGURATION_GENERAL_FAIL';

export const PUT_CONFIGURATION_GENERAL_REQUEST = 'PUT_CONFIGURATION_GENERAL_REQUEST';
export const PUT_CONFIGURATION_GENERAL_SUCCESS = 'PUT_CONFIGURATION_GENERAL_SUCCESS';
export const PUT_CONFIGURATION_GENERAL_FAIL = 'PUT_CONFIGURATION_GENERAL_FAIL';

export const LOAD_CONFIGURATION_TIME_RATE_REQUEST = 'LOAD_CONFIGURATION_TIME_RATE_REQUEST';
export const LOAD_CONFIGURATION_TIME_RATE_SUCCESS = 'LOAD_CONFIGURATION_TIME_RATE_SUCCESS';
export const LOAD_CONFIGURATION_TIME_RATE_FAIL = 'LOAD_CONFIGURATION_TIME_RATE_FAIL';

export const PUT_CONFIGURATION_TIME_RATE_REQUEST = 'PUT_CONFIGURATION_TIME_RATE_REQUEST';
export const PUT_CONFIGURATION_TIME_RATE_SUCCESS = 'PUT_CONFIGURATION_TIME_RATE_SUCCESS';
export const PUT_CONFIGURATION_TIME_RATE_FAIL = 'PUT_CONFIGURATION_TIME_RATE_FAIL';

export const LOAD_CONFIGURATION_MERIT_REQUEST = 'LOAD_CONFIGURATION_MERIT_REQUEST';
export const LOAD_CONFIGURATION_MERIT_SUCCESS = 'LOAD_CONFIGURATION_MERIT_SUCCESS';
export const LOAD_CONFIGURATION_MERIT_FAIL = 'LOAD_CONFIGURATION_MERIT_FAIL';

export const PUT_CONFIGURATION_MERIT_REQUEST = 'PUT_CONFIGURATION_MERIT_REQUEST';
export const PUT_CONFIGURATION_MERIT_SUCCESS = 'PUT_CONFIGURATION_MERIT_SUCCESS';
export const PUT_CONFIGURATION_MERIT_FAIL = 'PUT_CONFIGURATION_MERIT_FAIL';

export const LOAD_CONFIGURATION_DIRECTO_REQUEST = 'LOAD_CONFIGURATION_DIRECTO_REQUEST';
export const LOAD_CONFIGURATION_DIRECTO_SUCCESS = 'LOAD_CONFIGURATION_DIRECTO_SUCCESS';
export const LOAD_CONFIGURATION_DIRECTO_FAIL = 'LOAD_CONFIGURATION_DIRECTO_FAIL';

export const PUT_CONFIGURATION_DIRECTO_REQUEST = 'PUT_CONFIGURATION_DIRECTO_REQUEST';
export const PUT_CONFIGURATION_DIRECTO_SUCCESS = 'PUT_CONFIGURATION_DIRECTO_SUCCESS';
export const PUT_CONFIGURATION_DIRECTO_FAIL = 'PUT_CONFIGURATION_DIRECTO_FAIL';

export const LOAD_CONFIGURATION_PERSONA_REQUEST = 'LOAD_CONFIGURATION_PERSONA_REQUEST';
export const LOAD_CONFIGURATION_PERSONA_SUCCESS = 'LOAD_CONFIGURATION_PERSONA_SUCCESS';
export const LOAD_CONFIGURATION_PERSONA_FAIL = 'LOAD_CONFIGURATION_PERSONA_FAIL';

export const PUT_CONFIGURATION_PERSONA_REQUEST = 'PUT_CONFIGURATION_PERSONA_REQUEST';
export const PUT_CONFIGURATION_PERSONA_SUCCESS = 'PUT_CONFIGURATION_PERSONA_SUCCESS';
export const PUT_CONFIGURATION_PERSONA_FAIL = 'PUT_CONFIGURATION_PERSONA_FAIL';

export const LOAD_CONFIGURATION_CONFIRMATION_ACTIONS_REQUEST = 'LOAD_CONFIGURATION_CONFIRMATION_ACTIONS_REQUEST';
export const LOAD_CONFIGURATION_CONFIRMATION_ACTIONS_SUCCESS = 'LOAD_CONFIGURATION_CONFIRMATION_ACTIONS_SUCCESS';
export const LOAD_CONFIGURATION_CONFIRMATION_ACTIONS_FAIL = 'LOAD_CONFIGURATION_CONFIRMATION_ACTIONS_FAIL';

export const PUT_CONFIGURATION_CONFIRMATION_ACTIONS_REQUEST = 'PUT_CONFIGURATION_CONFIRMATION_ACTIONS_REQUEST';
export const PUT_CONFIGURATION_CONFIRMATION_ACTIONS_SUCCESS = 'PUT_CONFIGURATION_CONFIRMATION_ACTIONS_SUCCESS';
export const PUT_CONFIGURATION_CONFIRMATION_ACTIONS_FAIL = 'PUT_CONFIGURATION_CONFIRMATION_ACTIONS_FAIL';

export const POST_MAIN_REPORT_TO_MERIT_REQUEST = 'POST_MAIN_REPORT_TOPOST_MAIN_REPORT_TO_MERIT_REQUEST';
export const POST_MAIN_REPORT_TO_MERIT_SUCCESS = 'POST_MAIN_REPORT_TO_MERIT_SUCCESS';
export const POST_MAIN_REPORT_TO_MERIT_FAIL = 'POST_MAIN_REPORT_TO_MERIT_FAIL';

export const LOAD_WORK_TIME_CALCULATION_TYPES_REQUEST = 'LOAD_WORK_TIME_CALCULATION_TYPES_REQUEST';
export const LOAD_WORK_TIME_CALCULATION_TYPES_SUCCESS = 'LOAD_WORK_TIME_CALCULATION_TYPES_SUCCESS';
export const LOAD_WORK_TIME_CALCULATION_TYPES_FAIL = 'LOAD_WORK_TIME_CALCULATION_TYPES_FAIL';

export const LOAD_CONFIGURATION_AXAPTA_REQUEST = 'LOAD_CONFIGURATION_AXAPTA_REQUEST';
export const LOAD_CONFIGURATION_AXAPTA_SUCCESS = 'LOAD_CONFIGURATION_AXAPTA_SUCCESS';
export const LOAD_CONFIGURATION_AXAPTA_FAIL = 'LOAD_CONFIGURATION_AXAPTA_FAIL';

export const PUT_CONFIGURATION_AXAPTA_REQUEST = 'PUT_CONFIGURATION_AXAPTA_REQUEST';
export const PUT_CONFIGURATION_AXAPTA_SUCCESS = 'PUT_CONFIGURATION_AXAPTA_SUCCESS';
export const PUT_CONFIGURATION_AXAPTA_FAIL = 'PUT_CONFIGURATION_AXAPTA_FAIL';

export const LOAD_CONFIGURATIONS_BY_KEYWORD_REQUEST = 'LOAD_CONFIGURATIONS_BY_KEYWORD_REQUEST';
export const LOAD_CONFIGURATIONS_BY_KEYWORD_SUCCESS = 'LOAD_CONFIGURATIONS_BY_KEYWORD_SUCCESS';
export const LOAD_CONFIGURATIONS_BY_KEYWORD_FAIL = 'LOAD_CONFIGURATIONS_BY_KEYWORD_FAIL';

export const PUT_CONFIGURATIONS_BY_KEYWORD_REQUEST = 'PUT_CONFIGURATIONS_BY_KEYWORD_REQUEST';
export const PUT_CONFIGURATIONS_BY_KEYWORD_SUCCESS = 'PUT_CONFIGURATIONS_BY_KEYWORD_SUCCESS';
export const PUT_CONFIGURATIONS_BY_KEYWORD_FAIL = 'PUT_CONFIGURATIONS_BY_KEYWORD_FAIL';

export const loadConfigurationSuccess = (configurations) => ({ type: LOAD_CONFIGURATION_SUCCESS, configurations });
export const loadConfigurationRequest = () => ({ type: LOAD_CONFIGURATION_REQUEST });
export const loadConfigurationFail = (error) => ({ type: LOAD_CONFIGURATION_FAIL, error });

const putConfigurationSuccess = (configurations) => ({ type: PUT_CONFIGURATION_SUCCESS, configurations });
const putConfigurationRequest = () => ({ type: PUT_CONFIGURATION_REQUEST });
const putConfigurationFail = (error) => ({ type: PUT_CONFIGURATION_FAIL, error });

const loadConfigurationLunchRequest = () => ({ type: LOAD_CONFIGURATION_LUNCH_REQUEST });
const loadConfigurationLunchSuccess = (configurations) => ({ type: LOAD_CONFIGURATION_LUNCH_SUCCESS, configurations });
const loadConfigurationLunchFail = (error) => ({ type: LOAD_CONFIGURATION_LUNCH_FAIL, error });

const putConfigurationLunchRequest = () => ({ type: PUT_CONFIGURATION_LUNCH_REQUEST });
const putConfigurationLunchSuccess = (configurations) => ({ type: PUT_CONFIGURATION_LUNCH_SUCCESS, configurations });
const putConfigurationLunchFail = (error) => ({ type: PUT_CONFIGURATION_LUNCH_FAIL, error });

const loadConfigurationBreakRequest = () => ({ type: LOAD_CONFIGURATION_BREAK_REQUEST });
const loadConfigurationBreakSuccess = (configurations) => ({ type: LOAD_CONFIGURATION_BREAK_SUCCESS, configurations });
const loadConfigurationBreakFail = (error) => ({ type: LOAD_CONFIGURATION_BREAK_FAIL, error });

const putConfigurationBreakRequest = () => ({ type: PUT_CONFIGURATION_BREAK_REQUEST });
const putConfigurationBreakSuccess = (configurations) => ({ type: PUT_CONFIGURATION_BREAK_SUCCESS, configurations });
const putConfigurationBreakFail = (error) => ({ type: PUT_CONFIGURATION_BREAK_FAIL, error });

export const loadConfigurationTimeRateRequest = () => ({ type: LOAD_CONFIGURATION_TIME_RATE_REQUEST });
export const loadConfigurationTimeRateSuccess = (configurations) => ({ type: LOAD_CONFIGURATION_TIME_RATE_SUCCESS, configurations });
export const loadConfigurationTimeRateFail = (error) => ({ type: LOAD_CONFIGURATION_TIME_RATE_FAIL, error });

const putConfigurationTimeRateRequest = () => ({ type: PUT_CONFIGURATION_TIME_RATE_REQUEST });
const putConfigurationTimeRateSuccess = (configurations) => ({ type: PUT_CONFIGURATION_TIME_RATE_SUCCESS, configurations });
const putConfigurationTimeRateFail = (error) => ({ type: PUT_CONFIGURATION_TIME_RATE_FAIL, error });

export const loadConfigurationGeneralRequest = () => ({ type: LOAD_CONFIGURATION_GENERAL_REQUEST });
export const loadConfigurationGeneralSuccess = (configurations) => ({ type: LOAD_CONFIGURATION_GENERAL_SUCCESS, configurations });
export const loadConfigurationGeneralFail = (error) => ({ type: LOAD_CONFIGURATION_GENERAL_FAIL, error });

const putConfigurationGeneralRequest = () => ({ type: PUT_CONFIGURATION_GENERAL_REQUEST });
const putConfigurationGeneralSuccess = (configurations) => ({ type: PUT_CONFIGURATION_GENERAL_SUCCESS, configurations });
const putConfigurationGeneralFail = (error) => ({ type: PUT_CONFIGURATION_GENERAL_FAIL, error });

export const loadConfigurationMeritRequest = () => ({ type: LOAD_CONFIGURATION_MERIT_REQUEST });
export const loadConfigurationMeritSuccess = (configurations) => ({ type: LOAD_CONFIGURATION_MERIT_SUCCESS, configurations });
export const loadConfigurationMeritFail = (error) => ({ type: LOAD_CONFIGURATION_MERIT_FAIL, error });

const putConfigurationMeritRequest = () => ({ type: PUT_CONFIGURATION_MERIT_REQUEST });
const putConfigurationMeritSuccess = (configurations) => ({ type: PUT_CONFIGURATION_MERIT_SUCCESS, configurations });
const putConfigurationMeritFail = (error) => ({ type: PUT_CONFIGURATION_MERIT_FAIL, error });

export const loadConfigurationDirectoRequest = () => ({ type: LOAD_CONFIGURATION_DIRECTO_REQUEST });
export const loadConfigurationDirectoSuccess = (configurations) => ({ type: LOAD_CONFIGURATION_DIRECTO_SUCCESS, configurations });
export const loadConfigurationDirectoFail = (error) => ({ type: LOAD_CONFIGURATION_DIRECTO_FAIL, error });

const putConfigurationDirectoRequest = () => ({ type: PUT_CONFIGURATION_DIRECTO_REQUEST });
const putConfigurationDirectoSuccess = (configurations) => ({ type: PUT_CONFIGURATION_DIRECTO_SUCCESS, configurations });
const putConfigurationDirectoFail = (error) => ({ type: PUT_CONFIGURATION_DIRECTO_FAIL, error });

export const loadConfigurationPersonaRequest = () => ({ type: LOAD_CONFIGURATION_PERSONA_REQUEST });
export const loadConfigurationPersonaSuccess = (configurations) => ({ type: LOAD_CONFIGURATION_PERSONA_SUCCESS, configurations });
export const loadConfigurationPersonaFail = (error) => ({ type: LOAD_CONFIGURATION_PERSONA_FAIL, error });

const putConfigurationPersonaRequest = () => ({ type: PUT_CONFIGURATION_PERSONA_REQUEST });
const putConfigurationPersonaSuccess = (configurations) => ({ type: PUT_CONFIGURATION_PERSONA_SUCCESS, configurations });
const putConfigurationPersonaFail = (error) => ({ type: PUT_CONFIGURATION_PERSONA_FAIL, error });

export const loadConfigurationConfirmationActionsRequest = () => ({ type: LOAD_CONFIGURATION_CONFIRMATION_ACTIONS_REQUEST });
// eslint-disable-next-line max-len
export const loadConfigurationConfirmationActionsSuccess = (configurations) => ({ type: LOAD_CONFIGURATION_CONFIRMATION_ACTIONS_SUCCESS, configurations });
export const loadConfigurationConfirmationActionsFail = (error) => ({ type: LOAD_CONFIGURATION_CONFIRMATION_ACTIONS_FAIL, error });

const putConfigurationConfirmationActionsRequest = () => ({ type: PUT_CONFIGURATION_CONFIRMATION_ACTIONS_REQUEST });
// eslint-disable-next-line max-len
const putConfigurationConfirmationActionsSuccess = (configurations) => ({ type: PUT_CONFIGURATION_CONFIRMATION_ACTIONS_SUCCESS, configurations });
const putConfigurationConfirmationActionsFail = (error) => ({ type: PUT_CONFIGURATION_CONFIRMATION_ACTIONS_FAIL, error });

const postMainReportToMeritRequest = () => ({ type: POST_MAIN_REPORT_TO_MERIT_REQUEST });
const postMainReportToMeritSuccess = (configurations) => ({ type: POST_MAIN_REPORT_TO_MERIT_SUCCESS, configurations });
const postMainReportToMeritFail = (error) => ({ type: POST_MAIN_REPORT_TO_MERIT_FAIL, error });

export const loadWorkTimeCalculationTypesRequest = () => ({ type: LOAD_WORK_TIME_CALCULATION_TYPES_REQUEST });
export const loadWorkTimeCalculationTypesSuccess = (types) => ({ type: LOAD_WORK_TIME_CALCULATION_TYPES_SUCCESS, types });
export const loadWorkTimeCalculationTypesFail = (error) => ({ type: LOAD_WORK_TIME_CALCULATION_TYPES_FAIL, error });

const loadConfigurationAxaptaRequest = () => ({ type: LOAD_CONFIGURATION_AXAPTA_REQUEST });
const loadConfigurationAxaptaSuccess = (configurations) => ({ type: LOAD_CONFIGURATION_AXAPTA_SUCCESS, configurations });
const loadConfigurationAxaptaFail = (error) => ({ type: LOAD_CONFIGURATION_AXAPTA_FAIL, error });

const putConfigurationAxaptaRequest = () => ({ type: PUT_CONFIGURATION_AXAPTA_REQUEST });
const putConfigurationAxaptaSuccess = (configurations) => ({ type: PUT_CONFIGURATION_AXAPTA_SUCCESS, configurations });
const putConfigurationAxaptaFail = (error) => ({ type: PUT_CONFIGURATION_AXAPTA_FAIL, error });

export const loadConfigurationsByKeywordRequest = () => ({ type: LOAD_CONFIGURATIONS_BY_KEYWORD_REQUEST });
export const loadConfigurationsByKeywordSuccess = (configurations) => ({ type: LOAD_CONFIGURATIONS_BY_KEYWORD_SUCCESS, configurations });
export const loadConfigurationsByKeywordFail = (error) => ({ type: LOAD_CONFIGURATIONS_BY_KEYWORD_FAIL, error });

const putConfigurationsByKeywordRequest = () => ({ type: PUT_CONFIGURATIONS_BY_KEYWORD_REQUEST });
const putConfigurationsByKeywordSuccess = (configurations) => ({ type: PUT_CONFIGURATIONS_BY_KEYWORD_SUCCESS, configurations });
const putConfigurationsByKeywordFail = (error) => ({ type: PUT_CONFIGURATIONS_BY_KEYWORD_FAIL, error });

export const loadConfiguration = () => (dispatch) => {
  dispatch(loadConfigurationRequest());
  return communicate({ url: 'Configurations/Web' }).then((response) => {
    dispatch(loadConfigurationSuccess(response.data.Data));
  }).catch((e) => {
    toastrError(e);
    dispatch(loadConfigurationFail(e));
  });
};

export const putConfiguration = (data) => (dispatch) => {
  dispatch(putConfigurationRequest());

  return communicate({
    url: 'Configurations/Web',
    method: 'put',
    data
  }).then((response) => {
    toastrSuccess(response);
    dispatch(putConfigurationSuccess(response.data.Data));
  }).catch((e) => {
    dispatch(putConfigurationFail(e));
    toastrError(e);
  });
};

export const loadConfigurationLunch = () => (dispatch) => {
  dispatch(loadConfigurationLunchRequest());
  return communicate({ url: 'Configurations/Lunch' }).then((response) => {
    dispatch(loadConfigurationLunchSuccess(response.data.Data));
  }).catch((e) => {
    toastrError(e);
    dispatch(loadConfigurationLunchFail(e));
  });
};

export const putConfigurationLunch = (data) => (dispatch) => {
  dispatch(putConfigurationLunchRequest());
  return communicate({
    url: 'Configurations/Lunch',
    method: 'put',
    data
  }).then((response) => {
    toastrSuccess(response);
    dispatch(putConfigurationLunchSuccess(response.data.Data));
  }).catch((e) => {
    dispatch(putConfigurationLunchFail(e));
    toastrError(e);
  });
};

export const loadConfigurationBreak = () => (dispatch) => {
  dispatch(loadConfigurationBreakRequest());
  return communicate({ url: 'Configurations/Break' }).then((response) => {
    dispatch(loadConfigurationBreakSuccess(response.data.Data));
  }).catch((e) => {
    toastrError(e);
    dispatch(loadConfigurationBreakFail(e));
  });
};

export const putConfigurationBreak = (data) => (dispatch) => {
  dispatch(putConfigurationBreakRequest());
  return communicate({
    url: 'Configurations/Break',
    method: 'put',
    data
  }).then((response) => {
    toastrSuccess(response);
    dispatch(putConfigurationBreakSuccess(response.data.Data));
  }).catch((e) => {
    dispatch(putConfigurationBreakFail(e));
    toastrError(e);
  });
};

export const loadConfigurationTimeRate = () => (dispatch) => {
  dispatch(loadConfigurationTimeRateRequest());
  return communicate({ url: 'Configurations/DefaultTimeRate' }).then((response) => {
    dispatch(loadConfigurationTimeRateSuccess(response.data.Data));
  }).catch((e) => {
    toastrError(e);
    dispatch(loadConfigurationTimeRateFail(e));
  });
};

export const putConfigurationTimeRate = (data) => (dispatch) => {
  dispatch(putConfigurationTimeRateRequest());
  return communicate({
    url: 'Configurations/DefaultTimeRate',
    method: 'put',
    data
  }).then((response) => {
    toastrSuccess(response);
    dispatch(putConfigurationTimeRateSuccess(response.data.Data));
  }).catch((e) => {
    dispatch(putConfigurationTimeRateFail(e));
    toastrError(e);
  });
};

export const loadConfigurationGeneral = () => (dispatch) => {
  dispatch(loadConfigurationGeneralRequest());
  return communicate({ url: 'Configurations/General' }).then((response) => {
    dispatch(loadConfigurationGeneralSuccess(response.data.Data));
  }).catch((e) => {
    toastrError(e);
    dispatch(loadConfigurationGeneralFail(e));
  });
};

export const putConfigurationGeneral = (data) => (dispatch) => {
  dispatch(putConfigurationGeneralRequest());
  return communicate({
    url: 'Configurations/General',
    method: 'put',
    data
  }).then((response) => {
    toastrSuccess(response);
    dispatch(putConfigurationGeneralSuccess(response.data.Data));
  }).catch((e) => {
    dispatch(putConfigurationGeneralFail(e));
    toastrError(e);
  });
};

export const loadConfigurationMerit = () => (dispatch) => {
  dispatch(loadConfigurationMeritRequest());
  return communicate({ url: 'Configurations/Merit' }).then((response) => {
    dispatch(loadConfigurationMeritSuccess(response.data.Data));
    return response.data.Data;
  }).catch((e) => {
    toastrError(e);
    dispatch(loadConfigurationMeritFail(e));
  });
};

export const putConfigurationMerit = (data) => (dispatch) => {
  dispatch(putConfigurationMeritRequest());
  return communicate({
    url: 'Configurations/Merit',
    method: 'put',
    data
  }).then((response) => {
    toastrSuccess(response);
    dispatch(putConfigurationMeritSuccess(response.data.Data));
  }).catch((e) => {
    dispatch(putConfigurationMeritFail(e));
    toastrError(e);
  });
};

export const loadConfigurationDirecto = () => (dispatch) => {
  dispatch(loadConfigurationDirectoRequest());
  return communicate({ url: 'Configurations/Directo' }).then((response) => {
    dispatch(loadConfigurationDirectoSuccess(response.data.Data));
    return response.data.Data;
  }).catch((e) => {
    toastrError(e);
    dispatch(loadConfigurationDirectoFail(e));
  });
};

export const putConfigurationDirecto = (data) => (dispatch) => {
  dispatch(putConfigurationDirectoRequest());
  return communicate({
    url: 'Configurations/Directo',
    method: 'put',
    data
  }).then((response) => {
    toastrSuccess(response);
    dispatch(putConfigurationDirectoSuccess(response.data.Data));
  }).catch((e) => {
    dispatch(putConfigurationDirectoFail(e));
    toastrError(e);
  });
};

export const loadConfigurationPersona = () => (dispatch) => {
  dispatch(loadConfigurationPersonaRequest());
  return communicate({ url: 'Configurations/Persona' }).then((response) => {
    dispatch(loadConfigurationPersonaSuccess(response.data.Data));
    return response.data.Data;
  }).catch((e) => {
    toastrError(e);
    dispatch(loadConfigurationPersonaFail(e));
  });
};

export const putConfigurationPersona = (data) => (dispatch) => {
  dispatch(putConfigurationPersonaRequest());
  return communicate({
    url: 'Configurations/Persona',
    method: 'put',
    data
  }).then((response) => {
    toastrSuccess(response);
    dispatch(putConfigurationPersonaSuccess(response.data.Data));
  }).catch((e) => {
    dispatch(putConfigurationPersonaFail(e));
    toastrError(e);
  });
};

export const loadConfigurationConfirmationLevels = () => (dispatch) => {
  dispatch(loadConfigurationConfirmationActionsRequest());
  return communicate({ url: 'Configurations/ConfirmationLevels' }).then((response) => {
    dispatch(loadConfigurationConfirmationActionsSuccess(response.data.Data));
    return response.data.Data;
  }).catch((e) => {
    toastrError(e);
    dispatch(loadConfigurationConfirmationActionsFail(e));
    return Promise.reject(e);
  });
};

export const putConfigurationConfirmationLevels = (data) => (dispatch) => {
  dispatch(putConfigurationConfirmationActionsRequest());
  return communicate({
    url: 'Configurations/ConfirmationLevels',
    method: 'put',
    data
  }).then((response) => {
    toastrSuccess(response);
    dispatch(putConfigurationConfirmationActionsSuccess(response.data.Data));
  }).catch((e) => {
    dispatch(putConfigurationConfirmationActionsFail(e));
    toastrError(e);
  });
};

export const importMainReportToMerit = (data) => (dispatch) => {
  dispatch(postMainReportToMeritRequest());
  return edeApi.merit.sendToMeritCreate(data).then((response) => {
    toastrSuccess(response);
    dispatch(postMainReportToMeritSuccess(response.data));
    return response.data;
  }).catch((e) => {
    dispatch(postMainReportToMeritFail(e));
    toastrError(e);
  });
};

export const loadWorkTimeCalculationTypes = () => (dispatch) => {
  dispatch(loadWorkTimeCalculationTypesRequest());
  return communicate({ url: 'WorkTimeCalculationTypes' })
    .then(({ data }) => {
      dispatch(loadWorkTimeCalculationTypesSuccess(data.Data));
    })
    .catch((e) => {
      dispatch(loadWorkTimeCalculationTypesFail(e));
    });
};

export const loadConfigurationAxapta = () => (dispatch) => {
  dispatch(loadConfigurationAxaptaRequest());
  return communicate({ url: 'Configurations/Axapta' }).then((response) => {
    dispatch(loadConfigurationAxaptaSuccess(response.data.Data));
  }).catch((e) => {
    toastrError(e);
    dispatch(loadConfigurationAxaptaFail(e));
  });
};

export const putConfigurationAxapta = (data) => (dispatch) => {
  dispatch(putConfigurationAxaptaRequest());
  return communicate({
    url: 'Configurations/Axapta',
    method: 'put',
    data
  }).then((response) => {
    toastrSuccess(response);
    dispatch(putConfigurationAxaptaSuccess(response.data.Data));
  }).catch((e) => {
    dispatch(putConfigurationAxaptaFail(e));
    toastrError(e);
  });
};

export const loadConfigurationsByKeywords = (keywords = []) => (dispatch) => {
  dispatch(loadConfigurationsByKeywordRequest());
  return wtsApi.v2.configurationSearchCreate({ Keywords: keywords })
    .then((response) => {
      dispatch(loadConfigurationsByKeywordSuccess(response.data.Data));
    }).catch((e) => {
      toastrError(e);
      dispatch(loadConfigurationsByKeywordFail(e));
    });
};

export const putConfigurationsByKeywords = (newConfigs) => (dispatch) => {
  dispatch(putConfigurationsByKeywordRequest());
  return wtsApi.v2.configurationUpdateManyUpdate({ Configurations: newConfigs })
    .then((response) => {
      toastrSuccess(response);
      dispatch(putConfigurationsByKeywordSuccess(response.data.Data));
    }).catch((e) => {
      dispatch(putConfigurationsByKeywordFail(e));
      toastrError(e);
    });
};
